import { Link, useLocation } from 'react-router-dom';

const breadcrumbMap: Record<string, string> = {
  '/': '首页',
  '/categories': '游戏分类',
  '/articles': '最新资讯',
  '/about': '关于我们',
};

interface BreadcrumbProps {
  currentTitle?: string;
}

export default function Breadcrumb({ currentTitle }: BreadcrumbProps) {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items = [
    { label: '首页', path: '/', active: pathSegments.length === 0 },
  ];

  if (pathSegments.length > 0) {
    const parentPath = `/${pathSegments[0]}`;
    items.push({
      label: breadcrumbMap[parentPath] || pathSegments[0],
      path: parentPath,
      active: pathSegments.length === 1 && !currentTitle,
    });
  }

  if (currentTitle && pathSegments.length > 1) {
    items.push({
      label: currentTitle,
      path: location.pathname,
      active: true,
    });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1.5 text-sm">
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-base w-4 h-4 flex items-center justify-center"></i>
            )}
            {item.active ? (
              <span className="text-foreground-500 font-medium">{item.label}</span>
            ) : (
              <Link to={item.path} className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}